import type { VoidFunctionComponent } from 'react';

import { Icon, icons } from '../../../../generic';

/**
 * A simple component to show a nice "Waiting to scan..." message with a spinning icon.
 * Used in the Projects Dashboard when a project or release group has never been scanned.
 */
const WaitingToScan: VoidFunctionComponent = () => (
  <>
    <Icon icon={icons.circleO} hasSpin />
    <span className="margin-left-xs">
      Waiting to scan...
    </span>
  </>
);

export default WaitingToScan;
